import { __assign, __extends } from "tslib";
import { GlueServiceException as __BaseException } from "./GlueServiceException";
var CrawlerRunningException = (function (_super) {
    __extends(CrawlerRunningException, _super);
    function CrawlerRunningException(opts) {
        var _this = _super.call(this, __assign({ name: "CrawlerRunningException", $fault: "client" }, opts)) || this;
        _this.name = "CrawlerRunningException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, CrawlerRunningException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return CrawlerRunningException;
}(__BaseException));
export { CrawlerRunningException };
var SchedulerTransitioningException = (function (_super) {
    __extends(SchedulerTransitioningException, _super);
    function SchedulerTransitioningException(opts) {
        var _this = _super.call(this, __assign({ name: "SchedulerTransitioningException", $fault: "client" }, opts)) || this;
        _this.name = "SchedulerTransitioningException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, SchedulerTransitioningException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return SchedulerTransitioningException;
}(__BaseException));
export { SchedulerTransitioningException };
var ConflictException = (function (_super) {
    __extends(ConflictException, _super);
    function ConflictException(opts) {
        var _this = _super.call(this, __assign({ name: "ConflictException", $fault: "client" }, opts)) || this;
        _this.name = "ConflictException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ConflictException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return ConflictException;
}(__BaseException));
export { ConflictException };
export var RegistryStatus;
(function (RegistryStatus) {
    RegistryStatus["AVAILABLE"] = "AVAILABLE";
    RegistryStatus["DELETING"] = "DELETING";
})(RegistryStatus || (RegistryStatus = {}));
var ConditionCheckFailureException = (function (_super) {
    __extends(ConditionCheckFailureException, _super);
    function ConditionCheckFailureException(opts) {
        var _this = _super.call(this, __assign({ name: "ConditionCheckFailureException", $fault: "client" }, opts)) || this;
        _this.name = "ConditionCheckFailureException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ConditionCheckFailureException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return ConditionCheckFailureException;
}(__BaseException));
export { ConditionCheckFailureException };
export var BlueprintRunState;
(function (BlueprintRunState) {
    BlueprintRunState["FAILED"] = "FAILED";
    BlueprintRunState["ROLLING_BACK"] = "ROLLING_BACK";
    BlueprintRunState["RUNNING"] = "RUNNING";
    BlueprintRunState["SUCCEEDED"] = "SUCCEEDED";
})(BlueprintRunState || (BlueprintRunState = {}));
export var ColumnStatisticsType;
(function (ColumnStatisticsType) {
    ColumnStatisticsType["BINARY"] = "BINARY";
    ColumnStatisticsType["BOOLEAN"] = "BOOLEAN";
    ColumnStatisticsType["DATE"] = "DATE";
    ColumnStatisticsType["DECIMAL"] = "DECIMAL";
    ColumnStatisticsType["DOUBLE"] = "DOUBLE";
    ColumnStatisticsType["LONG"] = "LONG";
    ColumnStatisticsType["STRING"] = "STRING";
})(ColumnStatisticsType || (ColumnStatisticsType = {}));
export var ResourceShareType;
(function (ResourceShareType) {
    ResourceShareType["ALL"] = "ALL";
    ResourceShareType["FOREIGN"] = "FOREIGN";
})(ResourceShareType || (ResourceShareType = {}));
export var CatalogEncryptionMode;
(function (CatalogEncryptionMode) {
    CatalogEncryptionMode["DISABLED"] = "DISABLED";
    CatalogEncryptionMode["SSEKMS"] = "SSE-KMS";
})(CatalogEncryptionMode || (CatalogEncryptionMode = {}));
export var TaskType;
(function (TaskType) {
    TaskType["EVALUATION"] = "EVALUATION";
    TaskType["EXPORT_LABELS"] = "EXPORT_LABELS";
    TaskType["FIND_MATCHES"] = "FIND_MATCHES";
    TaskType["IMPORT_LABELS"] = "IMPORT_LABELS";
    TaskType["LABELING_SET_GENERATION"] = "LABELING_SET_GENERATION";
})(TaskType || (TaskType = {}));
export var TaskRunSortColumnType;
(function (TaskRunSortColumnType) {
    TaskRunSortColumnType["STARTED"] = "STARTED";
    TaskRunSortColumnType["STATUS"] = "STATUS";
    TaskRunSortColumnType["TASK_RUN_TYPE"] = "TASK_RUN_TYPE";
})(TaskRunSortColumnType || (TaskRunSortColumnType = {}));
export var SortDirectionType;
(function (SortDirectionType) {
    SortDirectionType["ASCENDING"] = "ASCENDING";
    SortDirectionType["DESCENDING"] = "DESCENDING";
})(SortDirectionType || (SortDirectionType = {}));
export var TransformStatusType;
(function (TransformStatusType) {
    TransformStatusType["DELETING"] = "DELETING";
    TransformStatusType["NOT_READY"] = "NOT_READY";
    TransformStatusType["READY"] = "READY";
})(TransformStatusType || (TransformStatusType = {}));
export var TransformSortColumnType;
(function (TransformSortColumnType) {
    TransformSortColumnType["CREATED"] = "CREATED";
    TransformSortColumnType["LAST_MODIFIED"] = "LAST_MODIFIED";
    TransformSortColumnType["NAME"] = "NAME";
    TransformSortColumnType["STATUS"] = "STATUS";
    TransformSortColumnType["TRANSFORM_TYPE"] = "TRANSFORM_TYPE";
})(TransformSortColumnType || (TransformSortColumnType = {}));
export var BackfillErrorCode;
(function (BackfillErrorCode) {
    BackfillErrorCode["ENCRYPTED_PARTITION_ERROR"] = "ENCRYPTED_PARTITION_ERROR";
    BackfillErrorCode["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    BackfillErrorCode["INVALID_PARTITION_TYPE_DATA_ERROR"] = "INVALID_PARTITION_TYPE_DATA_ERROR";
    BackfillErrorCode["MISSING_PARTITION_VALUE_ERROR"] = "MISSING_PARTITION_VALUE_ERROR";
    BackfillErrorCode["UNSUPPORTED_PARTITION_CHARACTER_ERROR"] = "UNSUPPORTED_PARTITION_CHARACTER_ERROR";
})(BackfillErrorCode || (BackfillErrorCode = {}));
export var PartitionIndexStatus;
(function (PartitionIndexStatus) {
    PartitionIndexStatus["ACTIVE"] = "ACTIVE";
    PartitionIndexStatus["CREATING"] = "CREATING";
    PartitionIndexStatus["DELETING"] = "DELETING";
    PartitionIndexStatus["FAILED"] = "FAILED";
})(PartitionIndexStatus || (PartitionIndexStatus = {}));
export var SchemaDiffType;
(function (SchemaDiffType) {
    SchemaDiffType["SYNTAX_DIFF"] = "SYNTAX_DIFF";
})(SchemaDiffType || (SchemaDiffType = {}));
export var StatementState;
(function (StatementState) {
    StatementState["AVAILABLE"] = "AVAILABLE";
    StatementState["CANCELLED"] = "CANCELLED";
    StatementState["CANCELLING"] = "CANCELLING";
    StatementState["ERROR"] = "ERROR";
    StatementState["RUNNING"] = "RUNNING";
    StatementState["WAITING"] = "WAITING";
})(StatementState || (StatementState = {}));
export var PermissionType;
(function (PermissionType) {
    PermissionType["CELL_FILTER_PERMISSION"] = "CELL_FILTER_PERMISSION";
    PermissionType["COLUMN_PERMISSION"] = "COLUMN_PERMISSION";
})(PermissionType || (PermissionType = {}));
var PermissionTypeMismatchException = (function (_super) {
    __extends(PermissionTypeMismatchException, _super);
    function PermissionTypeMismatchException(opts) {
        var _this = _super.call(this, __assign({ name: "PermissionTypeMismatchException", $fault: "client" }, opts)) || this;
        _this.name = "PermissionTypeMismatchException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, PermissionTypeMismatchException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return PermissionTypeMismatchException;
}(__BaseException));
export { PermissionTypeMismatchException };
export var FieldName;
(function (FieldName) {
    FieldName["CRAWL_ID"] = "CRAWL_ID";
    FieldName["DPU_HOUR"] = "DPU_HOUR";
    FieldName["END_TIME"] = "END_TIME";
    FieldName["START_TIME"] = "START_TIME";
    FieldName["STATE"] = "STATE";
})(FieldName || (FieldName = {}));
export var FilterOperator;
(function (FilterOperator) {
    FilterOperator["EQ"] = "EQ";
    FilterOperator["GE"] = "GE";
    FilterOperator["GT"] = "GT";
    FilterOperator["LE"] = "LE";
    FilterOperator["LT"] = "LT";
    FilterOperator["NE"] = "NE";
})(FilterOperator || (FilterOperator = {}));
export var CrawlerHistoryState;
(function (CrawlerHistoryState) {
    CrawlerHistoryState["COMPLETED"] = "COMPLETED";
    CrawlerHistoryState["FAILED"] = "FAILED";
    CrawlerHistoryState["RUNNING"] = "RUNNING";
    CrawlerHistoryState["STOPPED"] = "STOPPED";
})(CrawlerHistoryState || (CrawlerHistoryState = {}));
export var EnableHybridValues;
(function (EnableHybridValues) {
    EnableHybridValues["FALSE"] = "FALSE";
    EnableHybridValues["TRUE"] = "TRUE";
})(EnableHybridValues || (EnableHybridValues = {}));
export var ExistCondition;
(function (ExistCondition) {
    ExistCondition["MUST_EXIST"] = "MUST_EXIST";
    ExistCondition["NONE"] = "NONE";
    ExistCondition["NOT_EXIST"] = "NOT_EXIST";
})(ExistCondition || (ExistCondition = {}));
export var DeleteClassifierRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteClassifierResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteColumnStatisticsForPartitionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteColumnStatisticsForPartitionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteColumnStatisticsForTableRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteColumnStatisticsForTableResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteConnectionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteConnectionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteCrawlerRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteCrawlerResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteCustomEntityTypeRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteCustomEntityTypeResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteDatabaseRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteDatabaseResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteDevEndpointRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteDevEndpointResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteJobRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteJobResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteMLTransformRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteMLTransformResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeletePartitionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeletePartitionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeletePartitionIndexRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeletePartitionIndexResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteRegistryInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteRegistryResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteResourcePolicyRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteResourcePolicyResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteSchemaInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteSchemaResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteSchemaVersionsInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ErrorDetailsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SchemaVersionErrorItemFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteSchemaVersionsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteSecurityConfigurationRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteSecurityConfigurationResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteSessionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteSessionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteTableRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteTableResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteTableVersionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteTableVersionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteTriggerRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteTriggerResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteUserDefinedFunctionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteUserDefinedFunctionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteWorkflowRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteWorkflowResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetBlueprintRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetBlueprintResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetBlueprintRunRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BlueprintRunFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetBlueprintRunResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetBlueprintRunsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetBlueprintRunsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetCatalogImportStatusRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CatalogImportStatusFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetCatalogImportStatusResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetClassifierRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CsvClassifierFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GrokClassifierFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var JsonClassifierFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var XMLClassifierFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ClassifierFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetClassifierResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetClassifiersRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetClassifiersResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetColumnStatisticsForPartitionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BinaryColumnStatisticsDataFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BooleanColumnStatisticsDataFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DateColumnStatisticsDataFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DecimalNumberFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DecimalColumnStatisticsDataFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DoubleColumnStatisticsDataFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var LongColumnStatisticsDataFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StringColumnStatisticsDataFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ColumnStatisticsDataFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ColumnStatisticsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ColumnErrorFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetColumnStatisticsForPartitionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetColumnStatisticsForTableRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetColumnStatisticsForTableResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetConnectionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ConnectionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetConnectionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetConnectionsFilterFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetConnectionsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetConnectionsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetCrawlerRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetCrawlerResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetCrawlerMetricsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CrawlerMetricsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetCrawlerMetricsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetCrawlersRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetCrawlersResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetCustomEntityTypeRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetCustomEntityTypeResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetDatabaseRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DatabaseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetDatabaseResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetDatabasesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetDatabasesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetDataCatalogEncryptionSettingsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ConnectionPasswordEncryptionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var EncryptionAtRestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DataCatalogEncryptionSettingsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetDataCatalogEncryptionSettingsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetDataflowGraphRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetDataflowGraphResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetDevEndpointRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetDevEndpointResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetDevEndpointsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetDevEndpointsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetJobRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetJobBookmarkRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var JobBookmarkEntryFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetJobBookmarkResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetJobRunRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetJobRunResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetJobRunsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetJobRunsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetJobsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var LocationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CatalogEntryFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetMappingRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MappingEntryFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetMappingResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetMLTaskRunRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ExportLabelsTaskRunPropertiesFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var FindMatchesTaskRunPropertiesFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ImportLabelsTaskRunPropertiesFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var LabelingSetGenerationTaskRunPropertiesFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TaskRunPropertiesFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetMLTaskRunResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TaskRunFilterCriteriaFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TaskRunSortCriteriaFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetMLTaskRunsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TaskRunFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetMLTaskRunsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetMLTransformRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ColumnImportanceFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ConfusionMatrixFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var FindMatchesMetricsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var EvaluationMetricsFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SchemaColumnFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetMLTransformResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TransformFilterCriteriaFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TransformSortCriteriaFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetMLTransformsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MLTransformFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetMLTransformsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetPartitionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetPartitionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetPartitionIndexesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BackfillErrorFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var KeySchemaElementFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PartitionIndexDescriptorFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetPartitionIndexesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SegmentFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetPartitionsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetPartitionsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetPlanRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetPlanResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetRegistryInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetRegistryResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetResourcePoliciesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GluePolicyFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetResourcePoliciesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetResourcePolicyRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetResourcePolicyResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetSchemaInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetSchemaResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetSchemaByDefinitionInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetSchemaByDefinitionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SchemaVersionNumberFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetSchemaVersionInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetSchemaVersionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetSchemaVersionsDiffInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetSchemaVersionsDiffResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetSecurityConfigurationRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SecurityConfigurationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetSecurityConfigurationResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetSecurityConfigurationsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetSecurityConfigurationsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetSessionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetSessionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetStatementRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StatementOutputDataFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StatementOutputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StatementFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetStatementResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetTableRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TableFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetTableResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetTablesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetTablesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetTableVersionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TableVersionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetTableVersionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetTableVersionsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetTableVersionsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetTagsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetTagsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetTriggerRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetTriggerResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetTriggersRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetTriggersResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetUnfilteredPartitionMetadataRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetUnfilteredPartitionMetadataResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetUnfilteredPartitionsMetadataRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UnfilteredPartitionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetUnfilteredPartitionsMetadataResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetUnfilteredTableMetadataRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ColumnRowFilterFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetUnfilteredTableMetadataResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetUserDefinedFunctionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UserDefinedFunctionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetUserDefinedFunctionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetUserDefinedFunctionsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetUserDefinedFunctionsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetWorkflowRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetWorkflowResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetWorkflowRunRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetWorkflowRunResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetWorkflowRunPropertiesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetWorkflowRunPropertiesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetWorkflowRunsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetWorkflowRunsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ImportCatalogToGlueRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ImportCatalogToGlueResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListBlueprintsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListBlueprintsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListCrawlersRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListCrawlersResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CrawlsFilterFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListCrawlsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CrawlerHistoryFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListCrawlsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListCustomEntityTypesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListCustomEntityTypesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListDevEndpointsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListDevEndpointsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListJobsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListJobsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListMLTransformsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListMLTransformsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListRegistriesInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var RegistryListItemFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListRegistriesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListSchemasInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SchemaListItemFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListSchemasResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListSchemaVersionsInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SchemaVersionListItemFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListSchemaVersionsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListSessionsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListSessionsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListStatementsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListStatementsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListTriggersRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListTriggersResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListWorkflowsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListWorkflowsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutDataCatalogEncryptionSettingsRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutDataCatalogEncryptionSettingsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutResourcePolicyRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutResourcePolicyResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MetadataKeyValuePairFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutSchemaVersionMetadataInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutSchemaVersionMetadataResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutWorkflowRunPropertiesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PutWorkflowRunPropertiesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var QuerySchemaVersionMetadataInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var OtherMetadataValueListItemFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MetadataInfoFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
